var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87349 1.66836C7.84073 1.22928 6.70283 0.988096 5.50309 1.00046C5.50309 1.00046 5.49691 1.00046 5.49072 1.00046C4.29099 0.988096 3.15309 1.2231 2.12032 1.66836C1.42151 1.9652 0.976244 2.66402 1.00098 3.42468C1.0319 4.54402 1.07519 5.73758 1.11848 7.01771C1.13703 7.48771 1.32256 7.93916 1.65651 8.26692C2.72638 9.33061 3.88283 10.3077 5.13822 11.2044C5.35467 11.359 5.64533 11.359 5.86178 11.2044C7.11717 10.3139 8.27362 9.33061 9.34349 8.26692C9.67744 7.93916 9.86297 7.48771 9.88152 7.01771C9.92481 5.73758 9.9681 4.54402 9.99902 3.42468C10.0238 2.66402 9.57849 1.9652 8.87968 1.66836H8.87349Z",
    stroke: "#F8973E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47613 5.57617H3.52441",
    stroke: "#F8973E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49683 7.55523V3.60352",
    stroke: "#F8973E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.e942617e4c881fdd760f43904d6ef5b0.svg";
export { ForwardRef as ReactComponent };